(function() {
    'use strict';

    angular.module('GorillaBoy')
    .controller('ProprietorDiscardCheckoutModalController', [
        '$rootScope',
        '$scope',
        'AppConstants',
        'ResourceId',
        'ResourceName',
        'DocumentService',
        '$translate',
        'MessageManager',
        'ResourceService',
        'UserCollectionService',
        ProprietorDiscardCheckoutModalController
    ]);
    function ProprietorDiscardCheckoutModalController($rootScope, $scope, AppConstants, ResourceId, ResourceName, DocumentService, $translate, MessageManager, ResourceService, UserCollectionService) {
        $scope.modalForm = {
            reasonText : ''
        };
        $scope.messageText = '';
        $scope.apiCallInProgress = true;
        $scope.translationVariables = {
            ResourceName : ResourceName
        };

        DocumentService.getDocument(ResourceId, true).then(function(response) {
            var DocumentMetadata = response.data.Metadata,
                CheckoutInfo = DocumentMetadata.CheckoutInfo;

            UserCollectionService.getUserCollection([CheckoutInfo.CheckoutUserId])
                .then(function(Users) {
                    var User = Users[0];
                    if (User) {
                        $scope.messageText = $translate.instant('CHECKIN_CHECKOUT.PROPRIETOR_DISCARD_CHECKOUT_MODAL.MESSAGE_WITH_NO_DRAFT', {
                            FileName : DocumentMetadata.VersionMetadata.Name,
                        });
                    }
                    $scope.apiCallInProgress = false;
                }, $scope.failureCallback);
            $scope.translationVariables.ResourceName = DocumentMetadata.VersionMetadata.Name;
        }, $scope.failureCallback);

        $scope.failureCallback = function(response) {
            MessageManager.addErrorMessage($translate.instant('CHECKIN_CHECKOUT.CHECKIN_MODAL.ERROR_FETCHING_RESOURCE_INFO'));
            $scope.$dismiss();
        };

        $scope.discardCheckoutHandler = function() {
            $scope.apiCallInProgress = true;
            ResourceService.discardCheckout(ResourceId, $scope.modalForm.reasonText).then(function(response) {
                MessageManager.addSuccessMessage($translate.instant('CHECKIN_CHECKOUT.MESSAGES.DISCARD_CHECKOUT.SUCCESS'));
                $scope.$close();
            }, function(response) {
                MessageManager.addErrorMessage($translate.instant('CHECKIN_CHECKOUT.DISCARD_CHECKOUT_ERROR'));
                $scope.$dismiss();
            });
        };
    }
}());
